import Vue from 'vue';
import ARIA from './ARIA.vue';
import router from './router';
import store from './store/store';
import navbar from '@/components/navbar.vue';
import titlebar from '@/components/titlebar.vue';
import footnote from '@/components/footnote.vue';
import notificationCenter from '@/qux-common/components/notificationCenter.vue';
import togglebutton from '@/qux-common/components/togglebutton.vue';
import infoDialogBox from '@/qux-common/components/info-dialog-box.vue';
import modalDialog from '@/qux-common/components/modal-dialog.vue';
import tabGroup from '@/qux-common/components/tab-group.vue';
import tabItem from '@/qux-common/components/tab-item.vue';
import backNavBtn from '@/qux-common/components/back-nav-btn.vue';
import vuetify from './plugins/vuetify';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import draggable from 'vuedraggable';
import VueApexCharts from 'vue-apexcharts';


Vue.config.productionTip = false;

// enable lodash from anywhere in the app with this._ or this.lodash
Vue.use(VueLodash, { lodash: lodash });
Vue.use(VueApexCharts);

/*
	GLOBAL COMPONENTS
	no need to import per view - always available
*/

// third-party
Vue.component('draggable', draggable);
Vue.component('apexChart', VueApexCharts);

// QVO
Vue.component('navbar', navbar);
Vue.component('titlebar', titlebar);
Vue.component('footnote', footnote);
Vue.component('togglebutton', togglebutton);
Vue.component('infoDialogBox', infoDialogBox);
Vue.component('notificationCenter', notificationCenter);
Vue.component('modal-dialog', modalDialog);
Vue.component('tab-group', tabGroup);
Vue.component('tab-item', tabItem);
Vue.component('back-nav-btn', backNavBtn);



new Vue({
	router,
	store,
	vuetify,
	render: function (h) { return h(ARIA); }
}).$mount('#qvo-app');
